// Module
var code = `<div class="svc-menu-action">
  <div data-bind="click: function(s, args) { model.action(model); }, key2click: { processEsc: false }, 
    css: model.buttonClassName,  
    attr: { title: model.tooltip }">
    <div class="svc-menu-action__icon">
      <div class="svc-menu-action__icon-container">
        <!-- ko component: { name: 'sv-svg-icon', params: { iconName: model.iconName, size: 'auto' } } -->
        <!-- /ko -->
      </div>
    </div>
  </div>
</div>`;
// Exports
export default code;